/// <amd-module name="Artifacts/Upack/commands/GetLink" />
import { getLinkCommandCreator } from "Artifacts/Root/protocols/Commands";

export const createGetLinkCommand = getLinkCommandCreator();
